const Goods = {
    Furniture: [
        { Name: "Sofa1", Text: "Sofa: 1 Seater", ID: 1, CFT: 30 },
        { Name: "Sofa2", Text: "Sofa: 2 Seater", ID: 2, CFT: 45 },
        { Name: "Sofa3", Text: "Sofa: 3 Seater", ID: 3, CFT: 65 },
        { Name: "CenterTable", Text: "Centre Table", ID: 4, CFT: 12 },
        { Name: "ShoeRack", Text: "Shoe Rack", ID: 5, CFT: 20 },
        { Name: "TvUnit", Text: "TV Unit", ID: 6, CFT: 40 },
        { Name: "DiningTable", Text: "Dining Table", ID: 7, CFT: 45 },
        { Name: "DiningChair", Text: "Dinning Chair", ID: 8, CFT: 10 },
        { Name: "BookRack", Text: "Book shelf / Rack", ID: 9, CFT: 20 },
        { Name: "ShowCase", Text: "Show Case", ID: 10, CFT: 40 }
    ],
    Electronics: [
        { Name: "Fridge", Text: "Fridge", ID: 11, CFT: 15 },
        { Name: "WashingMC", Text: "Washing M/c", ID: 12, CFT: 4 },
        { Name: "Microwave", Text: "Microwave", ID: 13, CFT: 4 },
        { Name: "OTG", Text: "OTG", ID: 14, CFT: 1 },
        { Name: "CookingUtensils", Text: "Cooking Utensils", ID: 15, CFT: 5 },
        { Name: "GasStove", Text: "Gas Stove", ID: 16, CFT: 5 },
        { Name: "Grinder", Text: "Grinder", ID: 17, CFT: 5 },
        { Name: "WaterFilter", Text: "Water Filter", ID: 18, CFT: 8 },
        { Name: "Cooler", Text: "Cooler", ID: 19, CFT: 3 },
        { Name: "LED", Text: "LED", ID: 20, CFT: 10 },
        { Name: "MusicSystem", Text: "Music System", ID: 21, CFT: 6 },
        { Name: "Computer", Text: "Computer", ID: 22, CFT: 4 },
        { Name: "Printer", Text: "Printer", ID: 23, CFT: 5 },
        { Name: "AC", Text: "AC", ID: 24, CFT: 5 },
        { Name: "JUICER", Text: "JUICER/MIXER/GRINDER", ID: 25, CFT: 5 },
        { Name: "KitchenBoxes", Text: "Kitchen Boxes", ID: 26, CFT: 4 }
    ],
    BedRoom: [
        { Name: "SingleCot", Text: "Single Cot", ID: 27, CFT: 40 },
        { Name: "SingleMattress", Text: "Single Mattress", ID: 28, CFT: 10 },
        { Name: "DoubleBed", Text: "Double Bed", ID: 29, CFT: 58 },
        { Name: "DoubleMattress", Text: "Double Mattress", ID: 30, CFT: 20 },
        { Name: "Deewan", Text: "Deewan", ID: 31, CFT: 30 },
        { Name: "DressingTable", Text: "Dressing table", ID: 32, CFT: 30 },
        { Name: "Cupboard", Text: "Cupboard 3 door", ID: 33, CFT: 54 },
        { Name: "Almira", Text: "Almira", ID: 34, CFT: 40 },
        { Name: "SideTable", Text: "Side Table", ID: 35, CFT: 10 }

    ],
    Others: [
        { Name: "Trunks", Text: "Trunks", ID: 36, CFT: 5 },
        { Name: "MediumPots", Text: "Medium Pots", ID: 37, CFT: 5 },
        { Name: "LargePots", Text: "Large Pots", ID: 38, CFT: 8 },
        { Name: "IronBoard", Text: "Iron Board", ID: 39, CFT: 5 },
        { Name: "Ladder", Text: "Ladder", ID: 40, CFT: 10 },
        { Name: "Cycle", Text: "Cycle", ID: 41, CFT: 20 },
        { Name: "TreadMill", Text: "Tread Mill", ID: 42, CFT: 30 },
        { Name: "Suitcases", Text: "Suitcases", ID: 43, CFT: 5 },
        { Name: "Mirrors", Text: "Mirrors", ID: 44, CFT: 3 },
        { Name: "Pictures", Text: "Pictures", ID: 45, CFT: 3 },
        { Name: "Carpet", Text: "Carpet", ID: 46, CFT: 5 },
        { Name: "BabyCarCycle", Text: "Baby Car /cycle", ID: 47, CFT: 5 },
        { Name: "MotorBike", Text: "Motor Bike", ID: 48, CFT: 80 },
        { Name: "Almira", Text: "Almira", ID: 49, CFT: 54 },
        { Name: "LargeCupboard", Text: "Large Cupboard", ID: 50, CFT: 45 },
        { Name: "FoldingBed", Text: "Folding Bed", ID: 51, CFT: 10 },
        { Name: "ClothesBoxes", Text: "Clothes Boxes", ID: 52, CFT: 4 },
        { Name: "MiscBoxes", Text: "Misc Boxes", ID: 53, CFT: 4 },
    ]
}

export default Goods;